
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import Modal from './Modal.vue';

@Component({
	name: 'PromoDetailModal',
	components: {
		Modal
	}
})
export default class PromoDetailModal extends Vue {
	@Prop({ type: Object, required: true })
	readonly promo: any;

	@Prop({ type: String  })
	readonly promoHeadline: string;

	@Prop({ type: String })
	readonly promoDescription: String;

	@Prop({ type: Boolean, default: true })
	readonly includeHeader: boolean;

}
